import { Box, Icon, IconButton, Link } from '@mui/material';
import { FC } from 'react';
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import { COLORS } from '../../services/constants/colors';
import { IS_NEMAN } from '../../services/constants/env';

export const Footer: FC = () => {
	return (
		<footer>
			<section className="footer-copirigt" style={{ backgroundColor: COLORS.BACKGROUND_DARK }}>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						// alignItems: 'center',
						gap: '20px',
						fontSize: '.8rem',
					}}
				>
					<Box>
						{IS_NEMAN
							? '© Neman OÜ 2026. All rights reserved'
							: '© EAS Project 2026. All rights reserved'}
					</Box>
					{/* <Box
						sx={{
							display: 'flex',
							gap: '20px',
						}}
					>
						<Box>
							<Link color="#ffffffd0" underline="none" href="https://easproject.com/cookie-policy/">
								Cookie policy
							</Link>
						</Box>
						<Box>
							<Link color="#ffffffd0" underline="none" href="https://easproject.com/privacy-policy">
								Privacy policy
							</Link>
						</Box>
					</Box> */}
				</Box>
			</section>
		</footer>
	);
};
